<template>
  <div class="menu-layout">
    <div class="sidebar-container" :class="classObj">
      <div class="logo" @click.stop="goHome">
        <img src="@/assets/images/logo.png" />
        <div class="title">{{ PROJECT_NAME }}</div>
      </div>
      <SideBar class="sidebar" />
    </div>
    <div class="main-container">
      <div class="nav-header">
        <div class="left">
          <Hamburger
            id="hamburger-container"
            :is-active="sidebar.opened"
            class="hamburger-container"
            @toggleClick="toggleSideBar"
          />
        </div>
        <div class="center"></div>
        <div class="right">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" @command="handleCommand">
            <div class="avatar-wrapper" :style="{ paddingLeft: avatar ? '40px' : '0' }">
              <img v-if="avatar" :src="avatar" class="user-avatar" />
              <span class="user-name">{{ name || account }}</span>
              <i class="el-icon-caret-bottom" style="margin-right: 0.5em" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">
                <span style="display: block">个人信息</span>
              </el-dropdown-item>
              <el-dropdown-item command="resetPhone">
                <span style="display: block">修改手机号</span>
              </el-dropdown-item>
              <el-dropdown-item command="resetPassword">
                <span style="display: block">重置密码</span>
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <span style="display: block">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="main-app">
        <transition name="fade-transform" mode="out-in">
          <router-view :key="key" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { PROJECT_NAME } from "@/config";
import SideBar from "./components/Sidebar/index.vue";
import Hamburger from "./components/Hamburger";
export default {
  name: "MenuLayout",
  data() {
    return {
      PROJECT_NAME,
    };
  },
  components: {
    SideBar,
    Hamburger,
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      avatar: state => state.user.avatar,
      name: state => state.user.name,
      account: state => state.user.account,
    }),
    ...mapGetters("user", ["isEnterprise"]),
    key() {
      return this.$route.path;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  methods: {
    ...mapMutations(["SET_PHONE_DIALOG", "SET_PASSWORD_DIALOG", "SET_ACCOUNT_DIALOG"]),
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleCommand(command) {
      let path = "",
        type = "";
      // console.log("command ", command);
      switch (command) {
        case "profile":
          path = "/staging/dashboardInfo";
          type = this.isEnterprise ? "Enterprise" : "Personal";
          this.$router.push({ path, query: { type } });
          break;
        case "resetPassword":
          this.SET_PASSWORD_DIALOG(true);
          this.$router.push({ name: "AccountInformation" });
          break;
        case "resetPhone":
          this.SET_PHONE_DIALOG(true);
          this.$router.push({ name: "AccountInformation" });
          break;
        case "resetAccount":
          this.SET_ACCOUNT_DIALOG(true);
          this.$router.push({ name: "AccountInformation" });
          break;
        case "logout":
          this[command] && this[command]();
          break;
        default:
          break;
      }
    },
    async logout() {
      this.$confirm("确认退出登录？")
        .then(async () => {
          await this.$store.dispatch("user/logout");
          done();
        })
        .catch(_ => {});
    },
    openDialog(type) {
      if (type === "profile") {
        this.$refs.UserDialog && this.$refs.UserDialog.open();
      } else if (type === "resetPassword") {
        this.$refs.ResetPasswordDialog && this.$refs.ResetPasswordDialog.open();
      }
    },
    showProfile() {
      const h = this.$createElement;
      this.$notify({
        title: "个人信息",
        message: h("div", {}, ["姓名：" + this.name, h("br"), "账号：" + this.$store.state.user.account]),
        duration: 2000,
      });
    },
    goHome() {
      window.open(window.location.origin);
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/style/layout.less";
.menu-layout {
  height: 100%;
  width: 100%;
  min-height: @min2-height;
  min-width: @min2-width;
  overflow: hidden;
  display: flex;
  flex-direction: row;

  .sidebar-container {
    flex: 0 0 auto;
    width: @siderbar-width;
    &.hideSidebar {
      width: 64px !important;
    }
    // &.openSidebar {
    // }
    .logo {
      height: @header2-height;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 10px;
      cursor: pointer;
      img {
        max-height: 100%;
      }
      .title {
        flex: 1 1 0;
        overflow: hidden;
        white-space: nowrap;
        // margin-left: 10px;
        box-sizing: border-box;
        color: #333;
        font-weight: 600;
        line-height: 74px;
        font-size: 16px;
      }
    }
    .sidebar {
      height: calc(100% - @header2-height);
      overflow: hidden;
    }
  }
  .main-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: #f6f8fc;
    overflow: hidden;
    .nav-header {
      flex: 0 0 auto;
      height: @header2-height;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      & > .left {
        width: 34px;
        height: 34px;
        line-height: 34px;
        font-size: 0;
        background-color: white;
        text-align: center;
        border-radius: 50%;
        margin-left: 20px;
        flex: 0 0 auto;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
      & > .center {
        flex: 1 1 0;
        overflow: hidden;
      }
      & > .right {
        flex: 0 0 auto;
        margin-right: 20px;
        .right-menu-item {
          display: inline-block;
          font-size: 18px;
          color: #333;
          vertical-align: text-bottom;

          &.hover-effect {
            cursor: pointer;
            transition: background 0.3s;

            &:hover {
              background: rgba(0, 0, 0, 0.025);
            }
          }
        }

        .avatar-container {
          // margin-top: calc(74px / 2 - 17px);
          background-color: white;
          height: 34px;
          border-radius: 17px;

          .avatar-wrapper {
            height: 34px;
            border-radius: 20px;
            position: relative;
            padding-left: 40px;
            line-height: 34px;
            .user-avatar {
              position: absolute;
              left: 0px;
              top: 50%;
              margin-top: -20px;
              display: inline-block;
              cursor: pointer;
              width: 40px;
              height: 40px;
              border-radius: 20px;
              // vertical-align: middle;
            }
            .user-name {
              display: inline-block;
              padding: 0 0.5em 0 1em;
            }
            .el-icon-caret-bottom {
              cursor: pointer;
              font-size: 12px;
            }
          }
        }
      }
    }
    .main-app {
      flex: 1 1 0;
      overflow: hidden auto;
      box-sizing: border-box;
      padding: 0 20px 20px;
      & > div.page {
        background-color: #fff;
        border-radius: 8px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 20px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        ::v-deep {
          & > .header {
            flex: 0 0 auto;
            width: 100%;
            overflow: hidden;
          }
          & > .body {
            overflow: auto;
            width: 100%;
            flex: 1 1 0;
            height: 100%;
          }
          & > .footer {
            flex: 0 0 auto;
            width: 100%;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
